import "./Queries.scss";

import upload from "../../assets/images/icons/upload.svg";
import sortIcon from "../../assets/images/icons/sort.svg";
import star from "../../assets/images/icons/star-purple.svg";

import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Rating from '@mui/material/Rating';
import StarIcon from '@mui/icons-material/Star';
import { useState, useEffect } from 'react';
import axios from 'axios';
import SideBar from '../../components/SideBar/SideBar';
import TopNav from '../../components/TopNav/TopNav';

function Queries() {
    const sorts = ["name", "time", "rating", "status"];
    const headings = ["User", "Time", "Rating", "Text", "Status"];
    const [value, setValue] = useState(0);
    const [userQueries, setUserQueries] = useState([]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        async function getUserQueries() {
            try {
                const response = await axios.get(
                    "https://zona-app-server-584d567d8841.herokuapp.com/queries/user-queries"
                );
                setUserQueries(response.data);
            } catch (error) {
                console.log(`user queries get request didn't work. error: ${error}`);
            }
        }
        getUserQueries();
    }, []);

    function classForStatus(stat) {
        switch (stat) {
            case "New":
                return "queries__info-user-table-info-info-status--new";
            case "Solved":
                return "queries__info-user-table-info-info-status--solved";
            case "Cancelled":
                return "queries__info-user-table-info-info-status--cancelled";
            default:
                return "queries__info-user-table-info-info-status";
        }
    }

    function numStars(stars) {
        for (let i = 0; i < stars; i++) {
            return <img className="queries__info-user-table-info-info-text-icon" src={star} alt="purple star"></img>;
        }
    }

    return (
        <main>
            <TopNav />
            <div className='main-container'>
                <SideBar />
                <article style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <section className='queries'>
                        <div className='queries__top'>
                            <h1 className='queries__top-heading'>
                                Queries
                            </h1>
                            <button className='queries__top-clear'>
                                <p className='queries__top-clear-text'>
                                    Export data
                                </p>
                                <img className='queries__top-clear-icon' src={upload} alt='upload icon'></img>
                            </button>
                        </div>

                        <section className='no-data'>
                            <div className='no-data__container'>
                                <p className='no-data__container-text'>
                                    There is no queries data at this time
                                </p>

                            </div>
                        </section>

                        {/* <section className='queries__info'>
                            <Box sx={{ width: '100%', bgcolor: 'transparent' }}>
                                <TabContext value={value}>
                                    <TabList onChange={handleChange} variant='fullWidth'>
                                        <Tab sx={{ width: '50%', color: '#FFF' }} label="User Queries" value='1' />
                                        <Tab sx={{ width: '50%', color: '#FFF' }} label="Venue Queries" value='2' />
                                    </TabList>
                                    <TabPanel value='1'>
                                        <section className='queries__info-user'>
                                            <div className='queries__info-user-sorts'>
                                                {
                                                    sorts.map((sort, index) => (
                                                        <button key={index} className='queries__info-user-sorts-button'>
                                                            <p className='queries__info-user-sorts-button-text'>
                                                                Sort by {sort}
                                                            </p>
                                                            <img className='queries__info-user-sorts-button-icon' src={sortIcon} alt='three cascading horizontal lines'></img>
                                                        </button>
                                                    ))
                                                }
                                            </div>

                                            <table className='queries__info-user-table'>
                                                <thead className='queries__info-user-table-top'>
                                                    <tr className='queries__info-user-table-top-headings'>
                                                        {
                                                            headings.map((heading, index) => (
                                                                <th key={index} className='queries__info-user-table-top-headings-heading'>
                                                                    {heading}
                                                                </th>
                                                            ))
                                                        }
                                                    </tr>
                                                </thead>

                                                <tbody className='queries__info-user-table-info'>
                                                    {
                                                        userQueries.map(query => (
                                                            <tr key={query.id} className='queries__info-user-table-info-info'>
                                                                <td className='queries__info-user-table-info-info-text'>
                                                                    {query.userName}
                                                                </td>
                                                                <td className='queries__info-user-table-info-info-text'>
                                                                    {query.time}
                                                                </td>
                                                                <td className='queries__info-user-table-info-info-stars'>
                                                                    <Box
                                                                        sx={{
                                                                            width: 200,
                                                                            height: 50,
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            '& > legend': { mt: 2 },
                                                                        }}
                                                                    >
                                                                        <Rating
                                                                            name="text-feedback"
                                                                            value={query.rating}
                                                                            readOnly
                                                                            precision={0.5}
                                                                            emptyIcon={<StarIcon style={{ opacity: 0.55, }} fontSize="inherit" />}
                                                                        />

                                                                    </Box>
                                                                </td>
                                                                <td className='queries__info-user-table-info-info-text'>
                                                                    {query.text}
                                                                </td>
                                                                <td className='queries__info-user-table-info-info-text'>
                                                                    <p className={classForStatus(query.status)}>
                                                                        {query.status}
                                                                    </p>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>
                                            </table>
                                        </section>
                                    </TabPanel>
                                </TabContext>
                            </Box>
                        </section> */}
                    </section>

                </article>
            </div>
        </main>
    );
}

export default Queries;

